import { render } from "./SecondaryUsers.vue?vue&type=template&id=f0cb7c5c&scoped=true"
import script from "./SecondaryUsers.vue?vue&type=script&lang=js"
export * from "./SecondaryUsers.vue?vue&type=script&lang=js"

import "./SecondaryUsers.vue?vue&type=style&index=0&id=f0cb7c5c&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f0cb7c5c"]])

export default __exports__